<div class="question">
  <div class="upload-image-box" *ngIf="question.imageFile">
    <img [src]="question.imageFile">
  </div>
  <div class="number">{{number}}.</div>
  <div class="text">{{question.text}}</div>
</div>
<div class="optional-hint" *ngIf="!allQuestionsRequired">Вы можете пропустить этот вопрос.</div>
<div class="answer" [ngSwitch]="question.type.techId">

  <app-answer-options-execution #answer *ngSwitchCase="QUESTION_TYPES.SINGLE_ANSWER"
                                [executionId]="executionId"
                                [questionId]="question.questionId"
                                [options]="question.options"
                                [multiple]="false"
                                [minAnswers]="question.minAnswers"
                                [maxAnswers]="question.maxAnswers"
                                [required]="allQuestionsRequired"
                                (optionsChange)="onAnswerOptionsChange($event)"></app-answer-options-execution>

  <app-answer-options-execution #answer *ngSwitchCase="QUESTION_TYPES.MULTIPLE_ANSWER"
                                [executionId]="executionId"
                                [questionId]="question.questionId"
                                [options]="question.options"
                                [multiple]="true"
                                [minAnswers]="question.minAnswers"
                                [maxAnswers]="question.maxAnswers"
                                [required]="allQuestionsRequired"
                                (optionsChange)="onAnswerOptionsChange($event)"></app-answer-options-execution>

  <app-answer-text-execution #answer *ngSwitchCase="QUESTION_TYPES.TEXT_ANSWER"
                             [executionId]="executionId"
                             [questionId]="question.questionId"
                             [text]="question.answer"
                             [required]="allQuestionsRequired"
                             (textChange)="onAnswerTextChange($event)"></app-answer-text-execution>

</div>
